<template>
    <div>
        <!--HEADER NAVBAR START-->
        <SiteHeader style="width: 100%"></SiteHeader>
        <NavbarStatic style="width: 100%"></NavbarStatic>
        <!--HEADER NAVBAR END-->

        <!--CONTENTS START-->
        <div id="bannerCarousel" class="carousel slide" data-ride="carousel" style="margin-top: 20px;">
            <div class="carousel-inner">
                <div v-for="(slider, index) in resources.sliders" :key="index" :class="['carousel-item', { active: index === 0 }]">
                    <template v-if="slider.link !== ''">
                        <a :href="slider.link" target="_blank">
                            <img :src="slider.img" class="carousel-image" style="height: auto;">
                        </a>
                    </template>
                    <template v-else>
                        <img :src="slider.img" class="carousel-image" style="height: auto;">
                    </template>
                </div>
            </div>
            <a class="carousel-control-prev" href="#bannerCarousel" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#bannerCarousel" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>

        <div style="margin-top: 20px;">
            <center>
                <h1 :style="isWindowOnDesktop ? 'font-size: 3.5rem;' : 'font-size: 2rem;'"><span style="color: #012376;"><strong>Welcome to St. Scholastica's College Manila!</strong></span></h1>
            </center>
            <div class="container">
                <video :width="!isWindowOnDesktop ? '400' : '1020'" :height="!isWindowOnDesktop ? '500' : '840'" controls autoplay muted>
                    <source :src="resources.enrollment_guide" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
            <center>
                <h4><span style="color: #012376;"><strong>Empowering Students for Change</strong></span></h4>
            </center>
            <template v-if="isWindowOnDesktop">
                <div class="container">
                    <div class="row">
                        <div class="col-md-3">
                            <a :href="env_wp.APP_URL+'/programs/pre-school'">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.pre_school" alt="Pre-School"></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Preschool and Grade School</div></center>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-3">
                            <a :href="env_wp.APP_URL+'/programs/high-school'">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.jhs" alt="Junior High"></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Junior High School</div></center>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-3">
                            <a :href="env_wp.APP_URL+'/programs/high-school'">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.shs" alt="Senior High"></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Senior High School</div></center>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-3">
                            <a :href="env_wp.APP_URL+'/programs/night-secondary-school'">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.night_secondary" alt="Night Secondary School"></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Night Secondary School</div></center>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="container" style="margin-top: 30px;">
                    <div class="row">
                        <div class="col-md-3">
                            <a :href="env_wp.APP_URL+'/programs/college'">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.college" alt="College"></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">College</div></center>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-3">
                            <a :href="env_wp.APP_URL+'/programs/graduate-school'">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.grad_school" alt="Graduate School"></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Graduate School</div></center>
                                </div>
                            </a>
                        </div>

                        <div class="col-md-3">
                            <div class="card" style="width: 15rem; border-radius: 20px;">
                                <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.cognate" alt="Cognate Programs"></el-image>
                                <div class="overlay"></div>
                                <center><div class="centered-text">Cognate Programs</div></center>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="card" style="width: 15rem; border-radius: 20px;">
                                <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.ced" alt="CCED"></el-image>
                                <div class="overlay"></div>
                                <center><div class="centered-text">Center for Continuing Education and Development</div></center>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container" style="margin-top: 30px;">
                    <div class="row justify-content-center">
                        <div class="col-md-3">
                            <a href="https://sscmanila.orangeapps.ph/landing/sscmanila/" class="rounded-btn btn btn-ssa"><span style="color: white; font-size: 28px;">APPLY NOW</span></a>
                        </div>
                        <div class="col-md-3">
                            <a :href="env_wp.APP_URL+'/admission'" class="rounded-btn btn btn-ssa" style="margin-left: 5px;"><span style="color: white; font-size: 11px;">LEARN MORE ABOUT THE ADMISSION PROCESS</span></a>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="!isWindowOnDesktop">
                <div style="margin-top: 50px;">
                    <div class="container" style="margin-left: 75px; width: 75%;">
                        <div class="row">
                            <div class="col-md-3" style="margin-bottom: 10px; margin-right: 15px;">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.pre_school" alt="Pre-School" lazy></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Preschool and Grade School</div></center>
                                </div>
                            </div>

                            <div class="col-md-3" style="margin-bottom: 10px; margin-right: 15px;">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.jhs" alt="Junior High" lazy></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Junior High School</div></center>
                                </div>
                            </div>

                            <div class="col-md-3" style="margin-bottom: 10px; margin-right: 15px;">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.shs" alt="Senior High" lazy></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Senior High School</div></center>
                                </div>
                            </div>

                            <div class="col-md-3" style="margin-bottom: 10px; margin-right: 15px;">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.night_secondary" alt="Night Secondary School" lazy></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Night Secondary School</div></center>
                                </div>
                            </div>

                            <div class="col-md-3" style="margin-bottom: 10px; margin-right: 15px;">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.college" alt="College" lazy></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">College</div></center>
                                </div>
                            </div>

                            <div class="col-md-3" style="margin-bottom: 10px; margin-right: 15px;">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.grad_school" alt="Graduate School" lazt></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Graduate School</div></center>
                                </div>
                            </div>

                            <div class="col-md-3" style="margin-bottom: 10px; margin-right: 15px;">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.cognate" alt="Cognate Programs" lazy></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Cognate Programs</div></center>
                                </div>
                            </div>

                            <div class="col-md-3" style="margin-bottom: 10px; margin-right: 15px;">
                                <div class="card" style="width: 15rem; border-radius: 20px;">
                                    <el-image style="border-radius: 20px; width: 238px; height: 160px;" class="card-img-top" :src="resources.link_images.ced" alt="CCED" lazy></el-image>
                                    <div class="overlay"></div>
                                    <center><div class="centered-text">Center for Continuing Education and Development</div></center>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="container" style="margin-top: 30px; width: 75%;">
                        <div class="row justify-content-center">
                            <center>
                                <div class="col-md-3" style="margin-bottom: 10px;">
                                    <a href="https://sscmanila.orangeapps.ph/landing/sscmanila/" class="rounded-btn btn btn-ssa"><span style="color: white; font-size: 28px;">APPLY NOW</span></a>
                                </div>
                                <div class="col-md-3">
                                    <a :href="env_wp.APP_URL+'/admission'" class="rounded-btn btn btn-ssa" style="margin-left: 5px;"><span style="color: white;">LEARN MORE ABOUT<br/>THE ADMISSION PROCESS</span></a>
                                </div>
                            </center>
                        </div>
                    </div>

                </div>
            </template>
        </div>

        <div style="margin-top: 20px;">
            <center>
                <a :href="'https://www.facebook.com/story.php?story_fbid=823260259829255&id=100064358662594&rdid=JNAdqXPI7OJ3fxve'" target="_blank">
                    <img :style="{ maxWidth: isWindowOnDesktop ? '50%' : '90%' }" :src="resources.announcements.amnd_2025" alt="AMND 2025">
                </a>
            </center>
        </div>

        <div style="margin-top: 50px;">
            <center>
                <template v-if="isWindowOnDesktop">
                    <div class="row" style="margin-right: 0%;">
                        <div class="col-md-6" style="padding-right: 0%;">
                            <div class="justify-content-center" :style="isWindowOnDesktop ? 'background-color: #012376; height: 100%; padding-top: 100px; padding-bottom: 125px;' : 'background-color: #012376; height: 325px; padding-top: 25px; padding-bottom: 125px;'">
                                <br>
                                <br>
                                <h1 :style="isWindowOnDesktop ? 'font-size: 2.5rem; color: white;' : 'font-size: 2rem; color: white;'">WHAT PARENTS AND STUDENTS ARE SAYING</h1>
                                <br>
                                <br>
                                <h4 style="color: white;">
                                    From inspiring stories of academic achievements to heartfelt accounts <br>of character development, these testimonials offer a glimpse into the
                                    <br> profound influence of the education SSC Manila provides.
                                </h4>
                            </div>
                        </div>
                        <div class="col-md-6" style="padding-right: 0%;">
                            <div id="testimonyCarousel" class="carousel slide" data-ride="carousel" style="margin-top: 20px;">
                                <div class="carousel-inner">
                                    <div v-for="(rt, index) in resources.testimonials" :key="index" :class="['carousel-item', { active: index === 0 }]">
                                        <div class="justify-content-center" style="margin-top: 50px;">
                                            <h5 :style="!isWindowOnDesktop ? 'font-size: 1.05rem;' : ''">
                                                <span v-html="rt.testimony"></span>
                                            </h5>
                                            <div style="border-radius: 50%">
                                                <img :src="rt.pic" :alt="rt.name" class="image-fluid">
                                            </div>
                                            <h3 style="font-family: Arial;"><strong>{{ rt.name }}</strong></h3>
                                            <h4 :style="!isWindowOnDesktop ? 'font-size: 1.05rem;' : ''">{{ rt.description }}</h4>
                                        </div>
                                    </div>
                                </div>
                                <a class="carousel-control-prev" href="#testimonyCarousel" role="button" data-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Previous</span>
                                </a>
                                <a class="carousel-control-next" href="#testimonyCarousel" role="button" data-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="justify-content-center" :style="isWindowOnDesktop ? 'background-color: #012376; height: 300px; padding-top: 100px; padding-bottom: 125px;' : 'background-color: #012376; height: 325px; padding-top: 25px; padding-bottom: 125px;'">
                        <h1 :style="isWindowOnDesktop ? 'font-size: 2.5rem; color: white;' : 'font-size: 2rem; color: white;'">WHAT PARENTS AND STUDENTS ARE SAYING</h1>
                        <br>
                        <h4 style="color: white;">
                            From inspiring stories of academic achievements to heartfelt accounts <br>of character development, these testimonials offer a glimpse into the
                            <br> profound influence of the education SSC Manila provides.
                        </h4>
                    </div>

                    <div class="justify-content-center">
                        <div id="testimonyCarousel" class="carousel slide" data-ride="carousel" style="margin-top: 20px;">
                            <div class="carousel-inner">
                                <div v-for="(rt, index) in resources.testimonials" :key="index" :class="['carousel-item', { active: index === 0 }]">
                                    <div class="justify-content-center" style="margin-top: 50px;">
                                        <h5 :style="!isWindowOnDesktop ? 'font-size: 0.9rem;' : ''" class="p-3">
                                            <span v-html="rt.testimony"></span>
                                        </h5>
                                        <div style="border-radius: 50%">
                                            <img :src="rt.pic" :alt="rt.name" class="image-fluid">
                                        </div>
                                        <h3 style="font-family: Arial;"><strong>{{ rt.name }}</strong></h3>
                                        <h4 :style="!isWindowOnDesktop ? 'font-size: 0.9rem;' : ''">{{ rt.description }}</h4>
                                    </div>
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#testimonyCarousel" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true" style="color: black;"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#testimonyCarousel" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true" style="color: black;"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </template>
                <br>
                <br>
            </center>
        </div>
        <br>
        <div style="margin-top: 50px;">
            <center>
                <div class="justify-content-center container-fluid" style="">
                    <h1 style="font-size: 2rem; color: #012376;"><strong>FEATURED ALUMNAE</strong></h1>
                    <h4 style="color: #012376;">
                        Get to know the notable Schoalsticans who have made their mark in their respective fields and in the society.
                    </h4>
                </div>
                <br>
                <br>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-4">
                            <div style="border-radius: 50%">
                                <img :src="resources.alumni.pres_cory" alt="Late President Corazon Aquino" class="image-fluid" :style="!isWindowOnDesktop ? 'width: 40%; height: 40%' : 'width: 30%; height: 30%;'">
                            </div>
                            <h3 style="font-family: Arial; color: #012376;"><strong>Late President Corazon Aquino</strong></h3>
                            <h4 style="font-family: Arial; color: #012376;">GRADE SCHOOL '43</h4>
                        </div>
                        <div class="col-md-4">
                            <div style="border-radius: 50%">
                                <img :src="resources.alumni.dolly" alt="Dolly De Leon" class="image-fluid" :style="!isWindowOnDesktop ? 'width: 40%; height: 40%' : 'width: 30%; height: 30%'">
                            </div>
                            <h3 style="font-family: Arial; color: #012376;"><strong>Dolly De Leon</strong></h3>
                            <h4 style="font-family: Arial; color: #012376;">HIGH SCHOOL '86</h4>
                        </div>
                        <div class="col-md-4">
                            <div style="border-radius: 50%">
                                <img :src="resources.alumni.agnes" alt="Agnes Reoma" class="image-fluid" :style="!isWindowOnDesktop ? 'width: 40%; height: 40%' : 'width: 30%; height: 30%'">
                            </div>
                            <h3 style="font-family: Arial; color: #012376;"><strong>Agnes Reoma</strong></h3>
                            <h4 style="font-family: Arial; color: #012376;">COLLEGE '18</h4>
                        </div>
                    </div>
                </div>
            </center>
        </div>

        <div style="margin-top: 50px;">
            <template v-if="isWindowOnDesktop">
                <div class="row justify-content-center" style="margin-right: 0%;">
                    <div class="col-md-6">
                        <div style="padding-left: 10px;">
                            <iframe width="600" height="325" src="https://www.youtube.com/embed/Wl0rfGIcUkU" title="St. Scholastica's College Manila: Pundasyon" loading="lazy" allowfullscreen frameborder="0"></iframe>
                        </div>
                    </div>
                    <div class="col-md-6" style="padding-right: 0%;">
                        <div style="padding-left: 150px;">
                            <h1 style="font-size: 2rem; color: #012376; font-family: Arial;"><strong>What Makes a Scholastican?</strong></h1>
                            <br>
                            <h4 style="font-family: Arial;">
                                Watch the new <strong>Empowering Students for<br>
                                Change</strong> campaign video Entitled <i>"Pundasyon"</i>
                            </h4>
                            <br>
                            <p style="font-family: Arial;">
                                Get to know our Scholasticans and learn more about St. Scho<br>
                                Manila and its commitment to empowering students for<br>
                                change. The video features our Scholastican Ambassadors for<br>
                                2023: Senator Risa Hontiveros, Patricia Lasaten, Michelle Cobb,<br>
                                Selene L. Yu, Triciah Terada, Idr. Wilhelmina Garcia, and Maria<br>
                                Aurora Carandang Gloria.
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="!isWindowOnDesktop" class="pull-left">
                <center>
                    <h1 style="font-size: 2rem; color: #012376; font-family: Arial;"><strong>What Makes a Scholastican?</strong></h1>
                    <br>
                    <h4 style="font-family: Arial;">
                        Watch the new <strong>Empowering Students for<br>
                        Change</strong> campaign video Entitled <i>"Pundasyon"</i>
                    </h4>
                    <br>
                    <iframe width="400" height="175" src="https://www.youtube.com/embed/Wl0rfGIcUkU" title="St. Scholastica's College Manila: Pundasyon" loading="lazy" allowfullscreen frameborder="0"></iframe>
                    <br>
                    <p style="font-family: Arial;">
                        Get to know our Scholasticans and learn more about St. Scho<br>
                        Manila and its commitment to empowering students for<br>
                        change. The video features our Scholastican Ambassadors for<br>
                        2023: Senator Risa Hontiveros, Patricia Lasaten, Michelle Cobb,<br>
                        Selene L. Yu, Triciah Terada, Idr. Wilhelmina Garcia, and Maria<br>
                        Aurora Carandang Gloria.
                    </p>
                </center>
            </template>
        </div>

        <div style="margin-top: 20px; margin-bottom: 20px;">
            <div class="row" style="margin-left: 0; margin-right: 0;">
                <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" style="padding-right: 0px;">
                    &nbsp;
                </div>
                <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" :style="!isWindowOnDesktop ? 'padding-right: 0px;' : ''">
                    <button @click="scrollToTop()" class="btn btn-ssa pull-right"><span style="font-family: Arial; font-size: 2rem; color: #ffffff;"><strong><i class="fa fa-angle-double-up" aria-hidden="true"></i>Back to Top</strong></span></button>
                </div>
            </div>
        </div>

        <div style="margin-top: 40px; margin-bottom: 0px;">
            <div class="row justify-content-center" style="margin-left: 0; margin-right: 0;">
                <div class="col-md-6" :style="!isWindowOnDesktop ? 'margin-top: 100px; margin-right: 20px' : 'margin-top: 100px;'">
                    <div class="row">
                        <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" :style="!isWindowOnDesktop ? 'padding-right: 0px;' : ''">
                            <center>
                                <h1 style="font-size: 3.5rem; color: #012376; font-family: Arial; margin-bottom: 5px;"><strong>258</strong></h1>
                                <p style="font-family: Arial; margin-top: 0;">LAY MISSION PARTNERS</p>
                            </center>
                        </div>
                        <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" :style="!isWindowOnDesktop ? 'padding-right: 0px;' : ''">
                            <center>
                                <h1 style="font-size: 3.5rem; color: #012376; font-family: Arial; margin-bottom: 5px;"><strong>66</strong></h1>
                                <p style="font-family: Arial; margin-top: 0;">PAASCU ACCREDITED YEARS</p>
                            </center>
                        </div>
                        <div class="w-100"></div>
                        <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" :style="!isWindowOnDesktop ? 'padding-right: 0px;' : ''">
                            <center>
                                <h1 style="font-size: 3.5rem; color: #012376; font-family: Arial; margin-bottom: 5px;"><strong>119</strong></h1>
                                <p style="font-family: Arial; margin-top: 0;">YEARS ESTABLISHED</p>
                            </center>
                        </div>
                        <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" :style="!isWindowOnDesktop ? 'padding-right: 0px;' : ''">
                            <center>
                                <h1 style="font-size: 3.5rem; color: #012376; font-family: Arial; margin-bottom: 5px;"><strong>&nbsp;</strong></h1>
                                <p style="font-family: Arial; margin-top: 0;">&nbsp;</p>
                            </center>
                        </div>
                    </div>
                </div>
                <div :class="!isWindowOnDesktop ? 'col-md-2' : 'col-md-6'" style="padding-left: 0px; padding-right: 0px;">
                    <img style="width: 100%; height: 100%;" :src="env_wp.APP_URL+'/public/assets/img/ssa_manila/hompage/ssc_manila_population_count_assets/DSC03970 (2) (1).jpg'" alt="Scholasticans">
                </div>
            </div>
        </div>
        
        <!--CONTENTS END-->

        <!--FOOTER START-->
        <template v-if="isWindowOnDesktop">
            <div style="background: #012376;">
                <div class="row" style="margin-left: 0; margin-right: 0;">
                    &nbsp;
                </div>
            </div>
            <SiteFooter :style="{backgroundImage: `url('${env_wp.APP_URL}/public/assets/img/ssa_manila/hompage/footer_assets/comp/footer_backdrop.png')`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat', position: 'relative', width: '100%', paddingRight: 0}"></SiteFooter>
        </template>
        <!--FOOTER END-->
    </div>
</template>
<style scoped>
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
        background-color: transparent !important;
        background-size: 100% 100%;
        width: 2rem;
        height: 2rem;
    }

    .carousel-control-prev-icon {
        background-image: url("data:image/svg+xml;charset=utf8,<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='rgb(1,35,118)' class='bi bi-chevron-left' viewBox='0 0 16 16'><path fill-rule='evenodd' d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>");
    }

    .carousel-control-next-icon {
        background-image: url("data:image/svg+xml;charset=utf8,<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='rgb(1,35,118)' class='bi bi-chevron-right' viewBox='0 0 16 16'><path fill-rule='evenodd' d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>");
    }
    .el-carousel__item h3 {
        display: flex;
        color: #475669;
        opacity: 5;
        line-height: 300px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
    }
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #012376;
        border-radius: 20px;
        opacity: 75%;
    }

    .centered-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 16px;
        font-weight: bold;
        z-index: 1;
    }
    .btn-ssa{
        background-color: #012376;
    }
    .carousel-image {
        width: 100%;
        height: 100%;
        object-fit: fill;
    }


</style>
<script>
    import NavbarStatic from "../../../components/general/NavbarStatic";
    import SiteHeader from "../../../components/general/SiteHeader";
    import SiteFooter from "../../../components/general/SiteFooter";

    export default {
        props: {
            resources: Array
        },
        components: { NavbarStatic, SiteHeader, SiteFooter },
        data () {
            return {
                folder_name: this.$root.folder_name,
                env_wp: this.$root.env_wp.env_wp,
                screenWidth: window.innerWidth, // Initialize with current width
                isWindowOnDesktop: window.innerWidth > 768, // Initialize based on width
            }
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            });
            this.onResize();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        watch: {
            screenWidth(width) {
                this.isWindowOnDesktop = width > 768;
            },
        },
        methods: {
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            onResize() {
                this.screenWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            },
        }
    }
</script>

